
import axios from 'axios'
import wx from 'weixin-js-sdk'
import { getConfig } from '@/api/wx.js'
import { getintegral, operateCreditlist } from '@/api/user.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import config from '@/config'
import { Field, Popover, Button, ActionSheet } from 'vant'
import {
addLiked,
deleteLiked,
addCredit,
deleteMoments,
getBase,
checkList,
addComment,
deleteComment,
commentTip,
getCheckType
} from '@/api/yuangongquan'
export default {
directives: {
TransferDom
},
components: { XDialog, Popup, Swiper, SwiperItem, vanField: Field, vanPopover: Popover, vanButton: Button, vanActionSheet: ActionSheet },
data () {
return {
baseUrl: config.baseUrl,
id: this.$route.params.id,
owner_type: config.owner_type,
detailObj: {},
showmenu1: false,
showDialog: false,
creditList: [5, 10, 15, 20, 25, 30],
credit: 5,
integral: 0,
chekcType: [],
listObj: [], // 举报列表
showcomment: false,
commentObj: {},
commentText: '',
sendtext: '',
loop: '',
reportObj: '',
showreport: false,
reportlist: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
isAdmin () {

return this.$store.state.user.personObj.isAdmin
}
},
beforeRouteLeave (to, from, next) {
if (Object.keys(this.detailObj).length === 0) {
to.meta.isUseCache = false
} else {
to.meta.isUseCache = true
}
next()
},
mounted () {
this.getCheckList()
this.wxconfig()
this.getDetail()
this.getReport()
this.getreporttype()
},
watch: {
commentText: function (val) {
let temp = val.replace(/^\s*/, '')
this.sendtext = temp
}
},
methods: {
getreporttype () {
axios.get('https://www.zjftu.org/youzheng/sysDd/FTU_productComplaint_TYPE.action').then(data => {
this.reportlist = data.data
})
},
showreportlist (item, index) {
this.reportObj = item
this.showreport = true
},
report (type) {
this.showreport = false
commentTip({
commentid: this.reportObj.id,
accountid: this.accountid,
type: type
}).then(res => {
if (res.success) {
this.$vux.toast.text('举报成功!')
}
})
},
start (event, item, index) {
event.preventDefault()
this.$refs.comment[index].style.backgroundColor = '#bdbebe'
console.log()
clearTimeout(this.loop) 

this.loop = setTimeout(() => {
if (!item.isnew) {
item.showpopover = true
}
}, 600)
},
end (item, index) {
this.$refs.comment[index].style.backgroundColor = ''
clearTimeout(this.loop) 
},
onSelect (item, index) {
deleteComment({
id: item.id
}).then(res => {
if (res.success) {
this.$vux.toast.text(res.msg)
item.showpopover = false
item.isdelete = true
}
})
},
comment (item, index) {
this.commentObj = item
this.showcomment = true
},
submit () {
if (this.sendtext.length == 0) {
return false
}
addComment({
momentid: this.commentObj.id,
accountid: this.accountid,
comment: this.sendtext
}).then(res => {
if (res.success) {
this.$vux.toast.text(res.msg)
this.showcomment = false
console.log(this.$store.state.user.personObj.iconimgPATH)
this.detailObj.plList.unshift(
{
'filepath': this.$store.state.user.personObj.iconimgPATH,
'acctname': this.$store.state.user.personObj.acctname,
'createdate': '刚刚',
'comment': this.sendtext,
'isdelete': false,
'showpopover': false,
'isnew': true
}
)
}
})
},
getDetail () {
getBase({
id: this.id,
myuserid: this.userid
}).then(res => {
if (!res.obj) {
this.$vux.toast.text('已删除')
this.$router.go(-1)
} else {
this.detailObj = res.obj
}
})
},

zan () {
if (this.detailObj.mlike === '1') {
deleteLiked({
momentsid: this.detailObj.id,
userid: this.userid
}).then(res => {
let cnum =
this.detailObj.cnum === '' ? 0 : parseInt(this.detailObj.cnum)
this.$set(this.detailObj, 'cnum', cnum - 1)
this.$set(this.detailObj, 'mlike', '')
this.$vux.toast.text('取消点赞')
})
} else {
addLiked({
userid: this.userid,
uargetid: this.detailObj.userid,
momentsid: this.detailObj.id
}).then(res => {
let cnum =
this.detailObj.cnum === '' ? 0 : parseInt(this.detailObj.cnum)
this.$set(this.detailObj, 'cnum', cnum + 1)
this.$set(this.detailObj, 'mlike', '1')
this.$vux.toast.text('点赞成功')

operateCreditlist({
accountid: this.accountid,
rulecode: 'interact',
credit: 1,
owner_type: config.owner_type,
terminaltype: 2
})
})
}
},

shang () {






},

addCredit () {


























},
showpopup1 () {
this.showmenu1 = true
},

gotoCheck () {
this.$router.push({
name: 'yuangongquanReport',
params: { id: this.detailObj.id }
})
},

onDelete () {
let _this = this
this.$vux.confirm.show({
title: '提示信息',
content: '确定要删除吗？',
onConfirm () {
deleteMoments({
id: _this.detailObj.id
}).then(res => {
_this.showmenu1 = false
_this.$vux.toast.text('删除成功')
_this.detailObj = {}
_this.$router.go(-1)
})
}
})
},
getintegralTotal () {
/* 得到用户积分总信息 */
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue.allnow
})
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: [
'previewImage'
] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
})
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item.FILEPATH)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
},

getCheckList () {
getCheckType({
addTreeNode: 1
}).then(res => {
this.chekcType = res.obj
})
},

getReport () {
checkList({
pageSize: 100,
pageCurrent: this.pageCurrent,
id: this.id
}).then(res => {
let obj = res.obj
obj.forEach(item => {
item.checktypeName = []
let arr = item.checktype.split(';')
arr.map(o => {
this.chekcType.filter(m => {
m.key === o && item.checktypeName.push(m.value)
})
})
})
this.listObj = obj
})
},
gotoDetail () {
if (this.detailObj.userid !== this.userid) {
this.$router.push({ name: 'yuangongquanUserlist', params: { id: this.detailObj.userid } })
} else {
this.$router.push({ name: 'yuangongquanMy', params: { id: this.detailObj.userid } })
}
}
}
}
